import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  scrollToTop() {
    window.top.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
}
